/* eslint-disable @typescript-eslint/no-deprecated */

import React from 'react'
import styled from 'styled-components'
import { Caption } from '../../../../styles'

interface Props {
  caption: string
  clearAll: () => void
}

export const FilterList: React.FC<React.PropsWithChildren<Props>> = ({ caption, clearAll, children }) => {
  return (
    <Row>
      <Caption weight="600">{caption}</Caption>
      <ClearAll onClick={() => clearAll()}>Clear all</ClearAll>
      {children}
    </Row>
  )
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1rem;
`

const ClearAll = styled(Caption)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.grey.dark};
  text-decoration: underline;
  font-weight: 600;
  margin-bottom: 1rem;
`
